import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {
  KeyboardTypeOptions,
  SafeAreaView,
  TextInput,
  Text,
  View,
} from 'react-native';
import styleSheet from './styles';

interface AdminHeaderProps {
  title: string;
  children?: JSX.Element;
}

const AdminHeader = (props: AdminHeaderProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <SafeAreaView style={styles.container}>
      <Text style={styles.textStyle}>{props.title}</Text>
      {props.children}
    </SafeAreaView>
  );
};

export default AdminHeader;
